module.exports = __webpack_public_path__ + "static/media/send-2.4d46d2ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-2.svg
// module id = 1128
// module chunks = 1